import { clsx } from "clsx";
import { cn } from "@ui/lib/utils";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import IconArrowUp from "@ui/central-icons/icons/IconArrowUp";
import IconLoader from "@ui/central-icons/icons/IconLoader";

interface SubmitCircleButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  className?: string;
  "aria-label"?: string;
}

export function SubmitCircleButton({
  onClick,
  disabled,
  loading,
  label,
  className,
  "aria-label": ariaLabel,
}: SubmitCircleButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <button
      type='button'
      onClick={onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
      className={clsx(
        "tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-black tw-text-white tw-transition-opacity tw-duration-150",
        label ? "tw-gap-1.5 tw-py-2.5 tw-pl-4 tw-pr-3" : "tw-size-11",
        isDisabled ? "tw-opacity-40 tw-cursor-not-allowed" : "hover:tw-opacity-80",
        className,
      )}
    >
      {label && <span className='tw-type-sm tw-font-medium'>{label}</span>}
      {loading ? (
        <IconLoader
          className={cn(
            iconStrokeFix,
            label ? "tw-size-4 tw-text-white tw-animate-spin" : "tw-size-5 tw-text-white tw-animate-spin",
          )}
        />
      ) : (
        <IconArrowUp className={cn(iconStrokeFix, label ? "tw-size-4 tw-text-white" : "tw-size-5 tw-text-white")} />
      )}
    </button>
  );
}
